import React from "react";
import { Modal, Header, Progress } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
export default function ModalCalculatingRate({ percent }) {
  const [t] = useTranslation();
  return (
    <Modal
      open={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      style={{ maxWidth: 450 }}
    >
      <Modal.Content>
        <Header as="h4" textAlign="center" >
          <span dangerouslySetInnerHTML={{ __html: t('rate_calc_modal_header') }} />
        </Header>
        <div className="recommending-loader">
          <span className="percent">{percent}%</span>
          {t("rate_calc_modal_loader_label")}
          <Progress percent={percent} size="tiny" color="blue" autoSuccess />
        </div>
      </Modal.Content>
    </Modal>
  );
}
